export const COMPONENT_NAME = "admin-kyc-personal-information";
